import * as Sentry from "@sentry/react";
import { useContext } from "react";
import { Container } from "react-bootstrap";
import { useRouteError } from "react-router-dom";
import { UserContext } from "../auth/UserContext";

function ErrorElement(): JSX.Element {
  const error = useRouteError();
  const { user, logout } = useContext(UserContext);

  Sentry.captureException(error);

  const doLogout = () => {
    if (import.meta.env.PROD) {
      Sentry.setUser(null);
    }
    logout?.();
  };

  return (
    <Container className="mt-5">
      <h2>Something went wrong</h2>
      <p>
        {
          "There was an issue loading this page - this should trigger an automated alert in Sentry and in #eng-errors-prod, so this will get fixed soon."
        }
      </p>
      <p className="text-muted">
        Logged in as {user?.email}.{" "}
        <a href="#" onClick={doLogout}>
          Logout
        </a>
      </p>
    </Container>
  );
}

export default ErrorElement;
